import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  commonPadding: {
    padding: '16px 36px 24px'
  },
  formContent: {
    backgroundColor: palette.common.white,
    overflowY: 'auto',
    flexGrow: '1'
  },
  formTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px'
  },
  modalFooter: {
    padding: '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[400])
  },
  footerEven: {
    display: 'flex',
    justifyContent: 'space-between',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse'
    }
  },
  footerButton: {
    display: 'inline-block',
    '& + &': {
      marginLeft: '10px'
    },
    [breakpointsFunc.breakpoints.down('sm')]: {
      width: '100%',
      '& + &': {
        marginTop: '10px',
        marginLeft: '0'
      },
      '& button': {
        width: '100%'
      }
    }
  },
  footerWrapper: {
    display: 'flex',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '& + &': {
        marginBottom: '10px'
      }
    }
  },
  rightButton: {
    '& + &': {
      marginLeft: '10px'
    }
  },
  form: {
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch'
  },
  portfoliosRadioGroup: {
    display: 'flex',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    '& .MuiFormControlLabel-root': {
      width: '100%',
      '& .MuiTypography-root': {
        width: '100%'
      }
    }
  },
  portfoliosRadioGroupSelectAll: {
    paddingTop: 0,
    paddingBottom: 0,
    borderBottom: 'unset',
    '& .MuiTypography-root': {
      color: "".concat(palette.primary.main, " !important")
    }
  },
  portfoliosRadioGroupWrapper: {
    height: '410px',
    overflowY: 'auto',
    scrollbarGutter: 'stable',
    '& .MuiButtonBase-root': {
      '& .MuiTypography-root': {
        marginLeft: '6px'
      }
    }
  }
}));
export default useStyles;